import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import ButtonComponent from '../../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import ConfirmDeleteModalComponent from '../../../../components/ConfirmDeleteModalComponent';
import UserEditionModal from '../UsersManagementTab/UserEditionModal';
import React, { useContext, useEffect, useState } from 'react';
import {
  IUserProps,
  IUserSimpleProps,
} from '../../../../services/UserService/types';
import { AppContext } from '../../../../context/AppContextProvider';
import ButtonActionsComponent from '../../../../components/ButtonActionsComponent';
import {
  useDeleteUserAsync,
  useGetAllUserByLicenseAsync,
  useGetAllUsersByLicenseCountAsync,
  useGetUserByIdAsync,
} from '../../../../services/UserService/hooks/useMutation';
import { IRoleSimpleProps } from '../../../../services/RoleService/types';
import { Typography } from '@mui/material';
import { useGetAllRecognitionsByLicenseCountAsync } from '../../../../services/Recognition/hooks/useQuery';
import { IPaginationParams } from '../../../../services/types';
import { t } from 'i18next';

const UsersManagementTab = () => {
  const [users, setUsers] = useState<IUserSimpleProps[]>([]);
  const { showSnackbar } = useContext(AppContext);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageSize: 10,
    pageNumber: 1,
  });
  const [usersCount, setUsersCount] = useState(0);
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<
    IUserSimpleProps | IUserProps
  >();

  const { mutateAsync, isLoading: isLoadingGetAllUserByLicenseAsync } =
    useGetAllUserByLicenseAsync();
  const { mutateAsync: mutateUserGetById } = useGetUserByIdAsync();

  const { mutateAsync: mutateDeleteUserAsync, isLoading: isLoadingDeleteUser } =
    useDeleteUserAsync();

  const { mutateAsync: mutateUserCount, isLoading: isLoadingUsersCount } =
    useGetAllUsersByLicenseCountAsync();

  const columns: IColumnProps[] = [
    {
      id: 'name',
      label: t('configurationPage.users.name'),
      width: '40%',
    },
    {
      id: 'email',
      label: t('configurationPage.users.email'),
      width: '40%',
    },
    {
      id: 'roles',
      label: t('configurationPage.users.positions'),
      width: '20%',
      render: (value: any) => <>{rolesToRender(value)}</>,
    },
    {
      id: 'id',
      label: t('configurationPage.users.action'),
      width: 'min',
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(id)}
          handleEdit={() => handleEdit(id)}
        />
      ),
    },
  ];

  const rolesToRender = (roles: any) => {
    const render: any = roles.map((v: IRoleSimpleProps) => {
      return {
        name: v.name,
        hexadecimalColor: v.hexadecimalColor,
      };
    });

    return render.map((v: IRoleSimpleProps, index: any) => {
      return (
        <Typography
          color={v.hexadecimalColor}
          sx={{ color: v.hexadecimalColor }}
          style={{ color: v.hexadecimalColor }}
          key={index}
        >
          {v.name}
        </Typography>
      );
    });
  };

  const handleConfirmDeletion = () => {
    if (selectedItem?.id)
      mutateDeleteUserAsync(selectedItem?.id).then(() => {
        showSnackbar('Usuário excluído com sucesso.', 'success');
        setIsVisibleDeleteItemModal(false);
        reqAll();
      });
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItem(undefined);
  };

  const handleDeleteItem = (id: string) => {
    setSelectedItem(users.find((d) => d.id === id));
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: string) => {
    mutateUserGetById(id)
      .then(setSelectedItem)
      .then(() => setIsVisibleEditionModal(true));
  };

  const handleSave = () => {
    reqAll();
  };

  const reqAll = () => {
    mutateAsync(pagination).then(setUsers);
    mutateUserCount().then(setUsersCount);
  };

  useEffect(() => {
    reqAll();
  }, [pagination]);

  return (
    <>
      <TableComponent
        additionalTitleComponent={
          <ButtonComponent
            onClick={() => setIsVisibleEditionModal(true)}
            startIcon={<Add />}
          >
            {t('configurationPage.users.newUser')}
          </ButtonComponent>
        }
        onChangePageOrRowsPerPage={setPagination}
        isLoading={isLoadingGetAllUserByLicenseAsync || isLoadingUsersCount}
        title={t('configurationPage.users.title')}
        rows={users}
        totalCount={usersCount}
        columns={columns}
      />

      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteUser}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir usuário'}
        message={`Tem certeza que deseja excluir o usuário "${selectedItem?.name}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />

      <UserEditionModal
        handleSaveForm={handleSave}
        isOpen={isVisibleEditionModal}
        userToEdit={selectedItem}
        setIsOpen={setIsVisibleEditionModal}
      />
    </>
  );
};

export default UsersManagementTab;
